import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const requestsTypes = ["services", "programs"];

const RequestsType = () => {
  const { t } = useTranslation("goService", { keyPrefix: "myRequestsPage" });
  const [searchParams, setSearchParams] = useSearchParams();

  const type = searchParams.get("type") || "services";

  const handleChipClick = (requestType: string) => setSearchParams({ type: requestType });

  return (
    <Box sx={styles.container}>
      {requestsTypes.map((requestType) => (
        <Chip
          key={requestType}
          sx={styles.chip(requestType === type)}
          onClick={() => handleChipClick(requestType)}
          label={t(requestType)}
        />
      ))}
    </Box>
  );
};

export default RequestsType;

const styles = {
  container: {
    width: "fit-content",
    display: "flex",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    borderRadius: "8px",
    overflow: "hidden",
  },
  chip: (isActive: boolean) => ({
    borderRadius: "0",
    padding: "8px 16px",
    border: "none",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    borderRight: "1px solid var(--Gray-300, #D0D5DD)",

    background: isActive ? "var(--Base-White, #FFF)" : "var(--Gray-50, #F9FAFB)",
    color: isActive ? "var(--Gray-500, #667085)" : "var(--Gray-800, #182230)",

    "&:last-child": {
      borderRight: "none",
    },

    "&.MuiChip-root": {
      padding: "0",
    },
  }),
};
